export const COLORS ={
    // "#fdfbf9" 
    WHITE:'#FFFFFF',
    BLACK:'#000000',
    BACKGROUND:'#FFFFFF',
    PRIMARY:'#00b2ff'
}